import { FacilityType } from "./FacilityType";
import { InspectionPoint } from "./InspectionPoint";

export const InspectionPointStates = ['pending', 'passed', 'failed'] as const;
export type InspectionPointStatus = typeof InspectionPointStates[number];

export type FacilityInspection = {
    id:string,
    activityId:string,
    facilityId:string,
    facilityType:FacilityType,
    inspectionPoint:InspectionPoint,
    status:InspectionPointStatus,
    comment:string,
    initialInspectionUser: { id:string, name:string } | null,
    initialInspectionDate: Date | null,
    files:{
        privateFileName:string,
        publicFileName:string
    }[]
}

export type FacilityInspectionChangeRecord = 
{
    date:Date,
    user: { id:string, name:string }
} &
(
    { type:'update', status:InspectionPointStatus, comment:string } |
    { type:'fileAdded', privateFileName:string, publicFileName:string } |
    { type:'fileDeleted', privateFileName:string, publicFileName:string }
);